<template>
  <div class="py-3">
    <div class="py-3">
      <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca per Uti / Targa Carro"
              single-line
              hide-details
              style="max-width:300px;"
            />
    </div>
    <v-data-table 
      :items="utiList" 
      :headers="headers"
      :items-per-page="10"
      :search="search"
      :custom-filter="utiCustomFilter"
      :footer-props="{
        itemsPerPageText: 'Risultati per pagina',
        itemsPerPageAllText: 'Tutti',
        showFirstLastPage: true,
      }">

      <template v-slot:item.tipoMovimento="{ item }">
        <v-icon v-if="item.tipoMovimento==='ROB'" color="grey darken-2" large>
          <!-- mdi-arrow-collapse-vertical -->
          mdi-format-align-middle
        </v-icon>
        <v-icon v-if="item.tipoMovimento==='SCARICO'" color="success" large>
          mdi-upload       
        </v-icon>
        <v-icon v-if="item.tipoMovimento==='CARICO'" color="primary" large>
          mdi-download        
        </v-icon>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import ConvoyVisualizationMixins from '../mixins/convoyVisualizationMixins';

export default {
  name: "ConvoyUtiList",
  mixins: [ConvoyVisualizationMixins],
  data() {
    return {
      search: null,     
      headers: [
          { text: '', value: 'tipoMovimento', class: 'header text-uppercase' },
          { text: 'Tipo Carro', value: 'tipoCarro', class: 'header text-uppercase' },
          { text: 'Targa Carro', value: 'targaCarro', class: 'header text-uppercase' },
          { text: 'Parco binari', value: 'parcoBinari', class: 'header text-uppercase' },
          { text: 'Binario', value: 'binario', class: 'header text-uppercase' },
          // { text: 'Riserva', value: 'riserva', class: 'header text-uppercase' },
          { text: 'Tipo Uti', value: 'tipoUti', class: 'header text-uppercase' },     
          { text: 'Uti', value: 'utiNumber', class: 'header text-uppercase' },  
          { text: 'Descrizione merce', value: 'descrizioneMerce', class: 'header text-uppercase' },
          { text: 'Peso Lordo (Kg)', value: 'pesoLordo', class: 'header text-uppercase' },
          { text: 'Lunghezza', value: 'lunghezza', class: 'header text-uppercase' },
          { text: 'Area di Stoccaggio', value: 'areaDiStoccaggio', class: 'header text-uppercase' }, 
          { text: 'Stato', value: 'statoUti', class: 'header text-uppercase' },
          { text: 'Note', value: 'note', class: 'header text-uppercase' }
      ]
    };
  },
  computed: {
    utiList() {
      var ul = [];
      if (this.convoy.listCarri && this.convoy.listCarri.length > 0) {
        this.convoy.listCarri.forEach(wagon => {        
          wagon.listUti.forEach(utiWagon => {
            ul.push(this.toUtiListElement(wagon, utiWagon));
          });        
        });
      }
      return ul;
    }
  },
  props: {
    convoy: {
      type: Object,
      default: {}
    }
  },
  methods: {
    toUtiListElement(wagon, utiWagon) {
      // console.log("wagon ", wagon);
      // console.log("utiWagon ", utiWagon);
      var u = {};
      if (utiWagon.remainOnBoardScarico && utiWagon.remainOnBoardScarico===true) {
        u.tipoMovimento = 'ROB';
      } else if (utiWagon.tipoMovimento && utiWagon.tipoMovimento==='EXPORT') {
        u.tipoMovimento = 'SCARICO';
      } else if (utiWagon.tipoMovimento && utiWagon.tipoMovimento==='IMPORT') {
        u.tipoMovimento = 'CARICO';
      }
      u.riserva = false; // TODO calcolare la riserva come uti con booking per il viaggio ma senza uticarro
      u.tipoCarro = this.getCarroType(wagon);
      u.targaCarro = this.getCarroLicensePlate(wagon);
      var binario = this.convoy.binario;
      if (binario) {
        u.binario = binario.numero;
        if (binario.parcoBinari) {
          u.parcoBinari = binario.codiceParcoBinari;
        }
      }    
      u.tipoUti = this.getUtiType(utiWagon); // non trovo in rtb_uti il tipo uti !!
      u.utiNumber = this.getUtiCode(utiWagon);
      u.descrizioneMerce = utiWagon.visitaUti?utiWagon.visitaUti.merce:'';
      u.pesoLordo = this.getUtiWeight(utiWagon);
      u.lunghezza = this.getUtiLength(utiWagon);
      u.areaDiStoccaggio = 'TODO'; // TODO utiCarro.areaScarico attualmente ma non e' stesso parametro     
      u.statoUti = utiWagon.stato;
      u.note = utiWagon.noteScarico; // TODO uniformare note
      return u;
    },
    utiCustomFilter (value, search, item) {
      return item && search && (item.utiNumber || item.targaCarro)
        && (                  
          item.utiNumber.toLowerCase().includes(search.toLowerCase())
          || item.targaCarro.toLowerCase().includes(search.toLowerCase())
        );
    },
  }
};
</script>

<style scoped>

</style>